<!-- CUSTOM: bocket-actions-dropdown — BKT-003 -->
<!--
  Dropdown de acciones personalizadas Bocket en el header de conversacion.
  Ubicacion: entre <ResolveAction> y el boton de mas opciones (`...`) en MoreActions.vue.

  Patron clonado de MoreActions.vue para maxima compatibilidad con el design
  system de Chatwoot (ButtonV4 + DropdownMenu + v-on-clickaway).

  Feature flag: window.bocketConfig.customActionsEnabled (inyectada por
  _bocket_config.html.erb desde la ENV BOCKET_CUSTOM_ACTIONS_ENABLED).

  Para agregar nuevas opciones: editar `menuItems` y agregar el handler
  correspondiente en `handleAction`.
-->
<script setup>
import { computed } from 'vue';
import { useToggle } from '@vueuse/core';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';
import { copyTextToClipboard } from 'shared/helpers/clipboard';

import ButtonV4 from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const store = useStore();

const [showDropdown, toggleDropdown] = useToggle(false);

const currentChat = computed(() => store.getters.getSelectedChat);
const accountId = computed(() => store.getters.getCurrentAccountId);
const currentContact = computed(() => {
  const senderId = currentChat.value?.meta?.sender?.id;
  if (!senderId) return {};
  return store.getters['contacts/getContact'](senderId) || {};
});

const bocketEnabled = computed(
  () => window.bocketConfig?.customActionsEnabled === true
);

const menuItems = computed(() => [
  {
    icon: 'i-lucide-clipboard-copy',
    label: 'Copiar ficha',
    action: 'copy_ficha',
    value: 'copy_ficha',
  },
]);

const formatFicha = () => {
  const contact = currentContact.value;
  const conv = currentChat.value || {};
  const dashboardUrl = `${window.location.origin}/app/accounts/${accountId.value}/conversations/${conv.id}`;

  const lines = ['═══ Ficha de contacto ═══'];
  if (contact.name) lines.push(`Nombre: ${contact.name}`);
  if (contact.phone_number) lines.push(`Teléfono: ${contact.phone_number}`);
  if (contact.email) lines.push(`Email: ${contact.email}`);
  if (conv.id) lines.push(`Conversación: #${conv.id}`);
  lines.push(`Link: ${dashboardUrl}`);
  lines.push('═══════════════════════');
  return lines.join('\n');
};

const handleAction = async ({ action }) => {
  toggleDropdown(false);

  if (action === 'copy_ficha') {
    try {
      await copyTextToClipboard(formatFicha());
      useAlert('Ficha copiada al portapapeles');
    } catch (e) {
      useAlert('No se pudo copiar la ficha');
    }
  }

  // Nuevas acciones se agregan aqui: case por value/action.
};
</script>

<template>
  <div
    v-if="bocketEnabled"
    v-on-clickaway="() => toggleDropdown(false)"
    class="relative flex items-center group"
  >
    <ButtonV4
      v-tooltip="'Acciones Bocket'"
      size="sm"
      variant="ghost"
      color="slate"
      icon="i-lucide-chevron-down"
      trailing-icon
      label="Bocket"
      class="rounded-md group-hover:bg-n-alpha-2"
      @click="toggleDropdown()"
    />
    <DropdownMenu
      v-if="showDropdown"
      :menu-items="menuItems"
      class="mt-1 ltr:right-0 rtl:left-0 top-full"
      @action="handleAction"
    />
  </div>
</template>
